import { Direction } from './direction.enum';
import { IAuthorityPoint, AuthorityPoint } from './authoritypoint';

export class LineItem {

  id: string;
  lineNumber: string;
  fromPoint: AuthorityPoint;
  toPoint: AuthorityPoint;
  direction: Direction;
  cancelled: Date;
  operateOn: string;
  isUserCancelled: boolean;
  newDirection: Direction;


  constructor(lineItem: ILineItem) {
    this.id = lineItem.id;
    this.lineNumber = lineItem.lineNumber;
    this.fromPoint = new AuthorityPoint(lineItem.fromPoint);
    this.toPoint = new AuthorityPoint(lineItem.toPoint);
    this.direction = lineItem.direction;
    this.cancelled = lineItem.cancelled === undefined ? undefined : new Date(lineItem.cancelled);
    this.operateOn = lineItem.operateOn;
    this.isUserCancelled = lineItem.isUserCancelled === undefined ? false : lineItem.isUserCancelled;
    this.newDirection = lineItem.direction;

  }
}

export interface ILineItem {
  id: string;
  lineNumber: string;
  fromPoint: IAuthorityPoint;
  toPoint: IAuthorityPoint;
  direction: Direction;
  cancelled: number;
  operateOn: string;
  isUserCancelled: boolean;
  newDirection: Direction;
}
